import { useQueries } from '@tanstack/react-query';
import { createBatchedParamsArrayFromIds, influencerQueries } from '@round/api';
import { useCreatorImages } from 'Modules/Plans/CreatorSearch/hooks/useCreatorImages';

const exploreListOptions = influencerQueries.creatorExplore.options.list;

// Client influencer ids are UUIDs, so a selection of any size would outgrow the URL as one request.
const FETCH_BATCH_SIZE = 25;

/**
 * A client influencer id belongs to one client, so the ids alone are enough to match on. None of the
 * drawer's filters are sent: any of them could hide a selected creator.
 */
export function useSelectedCreators(creatorIds: string[]) {
    // No ids means no query at all, rather than one whose empty id filter would match every creator.
    const batchedParams = createBatchedParamsArrayFromIds(
        creatorIds,
        (batch) => ({ client_influencer_id: batch.join(',') }),
        FETCH_BATCH_SIZE
    );

    const queries = useQueries({
        queries: batchedParams.map((params) => exploreListOptions(params)),
    });

    const creatorGroups = queries.map((query) => query.data?.results ?? []);
    const { getCreatorImages, getAreCreatorImagesLoading } = useCreatorImages(creatorGroups);

    return {
        data: creatorGroups.flat(),
        isLoading: queries.some((query) => query.isLoading),
        hasError: queries.some((query) => query.isError),
        getCreatorImages,
        getAreCreatorImagesLoading,
    };
}
